export default "__VITE_ASSET__BdKlFMZu__"